export default __webpack_public_path__ + "static/media/big_home_icon.32670d8c.png";